import React, { useEffect, useState } from "react";
import { Check, Spinner, X } from "@phosphor-icons/react";
import { useDispatch, useSelector } from "react-redux";

import { setViewChats } from "src/store/slices/HomeSlice";
import { updateThreadTitle } from "src/pages/helpers";
import { trackAnalytics } from "src/pages/helpers";
import {
  BUTTON_ROLES,
  BUTTON_TYPES,
  EVENT_NAMES,
  EVENT_PARAMETERS,
  getPageName,
  MODAL_NAMES,
} from "src/utils/EventConstants";
const UpdateThreadTitleModal = (props) => {
  const { open, setActionOnThread, loading, setLoading, threadInfo, setRenameActiveId } = props;

  const dispatch = useDispatch();

  const [newTitle, setNewTitle] = useState("");
  const thread = threadInfo.thread;
  const duration = threadInfo.duration;

  const updatedTitle = useSelector((state) => state.threads.updatedTitle);
  const userMetadata = useSelector((state) => state.onboarding.userMetadata);
  const threadData = useSelector((state) => state.messageSlice.threadData);

  useEffect(() => {
    if (updatedTitle?.status === "success") {
      dispatch(setViewChats(true));
      setActionOnThread("");
      setLoading(false);
      setRenameActiveId("");
    }
  }, [updatedTitle]); // eslint-disable-line

  useEffect(() => {
    setNewTitle(thread?.title);
  }, [thread?.title, open]);

  useEffect(() => {
    if (open) {
      // Event 52:
      trackAnalytics(
        EVENT_NAMES.VIEWED_MODAL,
        {
          [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
          [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
          [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
          [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
          [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.RENAME_THREAD_MODAL,
        },
        userMetadata
      );
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    // <Modal
    //     centered
    //     open={open}
    //     onOk={() => setActionOnThread("")}
    //     onCancel={() => setActionOnThread("")}
    //     className="review-pop-up h-full rounded-[30px] bg-[#fff] overflow-hidden "
    //     footer={null}
    // >
    <div className="w-full h-[32px] flex flex-col">
      <div className="flex flex-row justify-between items-center w-full">
        <input
          id="update-title"
          data-testid="rename-thread-input"
          name="updateTitle"
          value={newTitle}
          onChange={(e) => {
            e.stopPropagation();
            setNewTitle(e.target.value);
          }}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === "Enter" && (e.target.tagName !== "TEXTAREA" || document.activeElement === e.target)) {
              // Event 53:
              trackAnalytics(
                EVENT_NAMES.CLICKED_BUTTON,
                {
                  [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
                  [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
                  [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.ENTER_KEY,
                  [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
                  [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_SUBMIT,
                  [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
                  [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.RENAME_THREAD_MODAL,
                },
                userMetadata
              );
              updateThreadTitle(dispatch, thread, duration, newTitle, setLoading);

              // updateThreadTitle(newTitle);
            }
          }}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          rows={1}
          style={{ resize: "none" }}
          className="px-[8px] !w-[300px] rounded-[5px] text-[12px] font-[500] text-black !h-[32px]  placeholder:text-black border-[1px] border-[#18475A] focus:outline-none focus:shadow-[0_0_0_3px_rgba(24,71,90,0.2)]"
          placeholder="Add New Chat Title"
        />
        <button
          disabled={loading || !newTitle || newTitle === thread?.title}
          className="btn-base btn-secondary flex justify-center !p-[8px] items-center w-full md:w-auto  text-[14px] md:text-[16px] gap-2"
          onClick={() => {
            // Event 54:
            trackAnalytics(
              EVENT_NAMES.CLICKED_BUTTON,
              {
                [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
                [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
                [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_ICON,
                [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
                [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_SUBMIT,
                [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
                [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.RENAME_THREAD_MODAL,
              },
              userMetadata
            );
            updateThreadTitle(dispatch, thread, duration, newTitle, setLoading);
          }}
          id="update-title-button"
          data-testid="rename-thread-submit-btn"
        >
          {loading ? (
            <Spinner size={16} className="animate-spin mx-auto my-auto" color="black" />
          ) : (
            <Check size={15} weight="bold" className="mx-auto my-auto mr-2" />
          )}
        </button>
        <button
          className="secondary-btn !p-[8px] w-auto flex text-[14px] md:text-[16px] border-[#D1D1D1]"
          onClick={() => {
            // Event 55:
            trackAnalytics(
              EVENT_NAMES.CLICKED_BUTTON,
              {
                [EVENT_PARAMETERS.PAGE_NAME]: getPageName(),
                [EVENT_PARAMETERS.THREAD_ID]: threadData?.id,
                [EVENT_PARAMETERS.BUTTON_TYPE]: BUTTON_TYPES.BUTTON_WITH_ICON,
                [EVENT_PARAMETERS.CURRENT_PLAN_TIER]: userMetadata?.subscription_type || "anonymous",
                [EVENT_PARAMETERS.BUTTON_ROLE]: BUTTON_ROLES.NAVIGATION_CLOSE,
                [EVENT_PARAMETERS.USER_ID]: userMetadata?.id,
                [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.RENAME_THREAD_MODAL,
              },
              userMetadata
            );
            setActionOnThread("");
            setRenameActiveId("");
          }}
          disabled={loading}
          id="cancel-update-title-button"
          data-testid="rename-thread-cancel-btn"
        >
          <X size={15} className="mr-2 text-black mx-auto my-auto" weight="bold" />
        </button>
      </div>
    </div>
    // </Modal>
  );
};

export default UpdateThreadTitleModal;
